module.exports = __webpack_public_path__ + "static/media/topbar_logo.2323bf3a.svg";